import React from "react";
import { FEATURES } from "../../mock/mock";
import { useReveal } from "../../hooks/useReveal";

export default function Features() {
  const ref = useReveal();
  return (
    <section className="py-20 lg:py-28 bg-white">
      <div ref={ref} className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-14 items-center">
        <div className="reveal order-2 lg:order-1">
          <span className="homi-section-tag text-homi-goldDark text-sm">{FEATURES.tag}</span>
          <h2 className="font-heading font-extrabold text-3xl md:text-4xl lg:text-5xl text-homi-black mt-3 mb-10 leading-tight">{FEATURES.title}</h2>
          <div className="grid sm:grid-cols-2 gap-8">
            {FEATURES.items.map((f) => {
              const Icon = f.icon;
              return (
                <div key={f.title} className="flex gap-4">
                  <div className="w-14 h-14 rounded-xl bg-homi-gold/15 flex items-center justify-center shrink-0">
                    <Icon className="w-7 h-7 text-homi-goldDark" />
                  </div>
                  <div>
                    <h3 className="font-heading font-bold text-lg text-homi-black mb-1">{f.title}</h3>
                    <p className="text-homi-body text-sm leading-relaxed">{f.desc}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="reveal order-1 lg:order-2 relative" style={{ transitionDelay: "120ms" }}>
          <div className="rounded-3xl overflow-hidden shadow-xl">
            <img src={FEATURES.image} alt="Quality work" className="w-full h-[440px] object-cover" />
          </div>
          <div className="absolute -top-5 -left-5 w-24 h-24 rounded-2xl bg-homi-gold/20 -z-0 hidden md:block" />
        </div>
      </div>
    </section>
  );
}
